import { useEffect, useState } from "react";
import { contentBase, loadBookDoc } from "./contentApi";

/**
 * 마법 장면 id(`poljjak.p05` · `ar_seokguram`)를 사람 말로 — 「《폴짝》 6쪽」 · 「🃏 경주 카드 「석굴암」」.
 * 쪽 id 와 쪽 번호는 한 칸 어긋난다(표지가 1쪽) — 그래서 책 차례를 읽어 센다.
 * 못 읽은 것은 비워 둔다 — 화면은 장면 id 를 그대로 보인다(이름을 지어내지 않는다).
 */
export function useSceneNames(sceneIds: readonly string[]): Record<string, string> {
  const [names, setNames] = useState<Record<string, string>>({});
  const key = [...sceneIds].sort().join(",");
  useEffect(() => {
    let alive = true;
    const ids = key ? key.split(",") : [];
    const cards = ids.filter((id) => !id.includes("."));
    if (cards.length) {
      void fetch(`${contentBase()}/content/ar-scenes.json`, { cache: "no-store" })
        .then((r) => (r.ok ? r.json() : null))
        .then((raw: unknown) => {
          if (!alive || !raw) return;
          const list = Array.isArray(raw) ? raw : ((raw as { scenes?: unknown[] }).scenes ?? []);
          const next: Record<string, string> = {};
          for (const it of list as { id?: unknown; title_ko?: unknown }[]) {
            if (typeof it.id === "string" && typeof it.title_ko === "string") next[it.id] = `🃏 경주 카드 「${it.title_ko}」`;
          }
          setNames((w) => ({ ...w, ...next }));
        })
        .catch(() => undefined); // 카드 제목을 못 읽으면 장면 id 로 보인다 — 표 자체는 그대로
    }
    for (const b of new Set(ids.filter((id) => id.includes(".")).map((id) => id.split(".")[0]!))) {
      void loadBookDoc(b)
        .then((doc) => {
          if (!alive) return;
          const title = typeof doc.title_ko === "string" ? doc.title_ko : b;
          const next: Record<string, string> = {};
          doc.pages.forEach((p, i) => {
            const pid = String((p as { id?: unknown }).id ?? "");
            if (pid) next[`${b}.${pid}`] = `《${title}》 ${i + 1}쪽`;
          });
          setNames((w) => ({ ...w, ...next }));
        })
        .catch(() => undefined); // 쪽 번호를 못 읽으면 장면 id 로 보인다 — 표 자체는 그대로
    }
    return () => {
      alive = false;
    };
  }, [key]);
  return names;
}
